// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.root[data-v-89e59892]
	{
		font-size: 16px;
		display: flex;
		flex-direction: column;
		align-items: center;
		width: 100%;
		height: 100%;
}
.head[data-v-89e59892]
	{
		width: 100%;
}
.body[data-v-89e59892]
	{
		width: 100%;
}
`, "",{"version":3,"sources":["webpack://./www/vues/admin/AdminLayout.vue"],"names":[],"mappings":";AA0CC;;EAEC,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,YAAY;AACb;AAEA;;EAEC,WAAW;AACZ;AAEA;;EAEC,WAAW;AACZ","sourcesContent":["<template>\r\n\t<div class=\"root\">\r\n\t\t<div class=\"head\">\r\n\t\t\t<AdminMenu></AdminMenu>\r\n\t\t</div>\r\n\t\t<div class=\"body\">\r\n\t\t\t<router-view></router-view>\r\n\t\t</div>\r\n\t\t<Footer />\r\n\t</div>\r\n</template>\r\n\r\n<script>\r\n\r\n\timport AdminMenu from 'appRoot/vues/admin/AdminMenu.vue';\r\n\timport Footer from 'appRoot/vues/common/Footer.vue';\r\n\timport EventBus from 'appRoot/scripts/EventBus';\r\n\r\n\texport default {\r\n\t\tcomponents: { AdminMenu, Footer },\r\n\t\tdata: function ()\r\n\t\t{\r\n\t\t\treturn {\r\n\t\t\t};\r\n\t\t},\r\n\t\tcreated()\r\n\t\t{\r\n\t\t},\r\n\t\tmounted()\r\n\t\t{\r\n\t\t\tEventBus.OnResize();\r\n\t\t},\r\n\t\tcomputed:\r\n\t\t{\r\n\t\t},\r\n\t\tmethods:\r\n\t\t{\r\n\t\t}\r\n\t};\r\n</script>\r\n\r\n<style scoped>\r\n\t.root\r\n\t{\r\n\t\tfont-size: 16px;\r\n\t\tdisplay: flex;\r\n\t\tflex-direction: column;\r\n\t\talign-items: center;\r\n\t\twidth: 100%;\r\n\t\theight: 100%;\r\n\t}\r\n\r\n\t.head\r\n\t{\r\n\t\twidth: 100%;\r\n\t}\r\n\r\n\t.body\r\n\t{\r\n\t\twidth: 100%;\r\n\t}\r\n</style>"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
